function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.835 10.414c.342-.245.666-.518.967-.814M3.199 9.6c.3.297.624.57.967.817M7.875 4.025V2.623C7.875 2 8.379 1.497 9 1.497v0c.622 0 1.126.504 1.126 1.126v1.403",
  stroke: "currentColor",
  strokeWidth: "1.15",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "9",
  cy: "5.999",
  r: "2.251",
  stroke: "currentColor",
  strokeWidth: "1.15",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.684 8.148l3.802 7.605h1.517v-3.001L11.17 5.09a2.428 2.428 0 00-2.17-1.342v0c-.92 0-1.761.52-2.172 1.342l-3.831 7.662v3.001h1.5l3.803-7.605M11.426 11.632a8.235 8.235 0 01-4.865-.006",
  stroke: "currentColor",
  strokeWidth: "1.15",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.963 5.999a.038.038 0 10.075 0 .038.038 0 00-.075 0",
  stroke: "currentColor",
  strokeWidth: "1.15",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));